import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { getOrderOrderStatusHistoryDiff } from "@/shared/v2/utils/helpers";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const OrderTooltip = ({ order }: { order: OrderV2 }) => {
  const { t } = useTranslation();
  const assignedCourierTimeStamp =
    order.order_information.assigned_courier_id_time_stamp;
  const hasDelivered = order?.order_information?.order_status_history?.[5];
  return (
    <ul style={{ padding: "1rem", margin: 0 }}>
      {getOrderOrderStatusHistoryDiff(
        order.order_information.order_status_history
      ).map((rule, index) => (
        <li key={index}>
          {t(rule.key, {
            old: t(rule.old),
            new: t(rule.new),
            hour: rule?.hour,
            min: rule?.min,
          })}
        </li>
      ))}
      {assignedCourierTimeStamp && hasDelivered && (
        <li>
          {t("deliveryDuration", {
            value: dayjs(hasDelivered).diff(assignedCourierTimeStamp, "minute"),
          })}
        </li>
      )}
    </ul>
  );
};

export default OrderTooltip;
